import axios from 'axios'
import {useAdminOptionsStore} from "@/stores/AdminOptionsStore";
import Snackbar from "@/components/Snackbar";
import Alert from "@/components/Alert";
import {mapWritableState} from "pinia";


if (window.location.hostname.indexOf('localhost') !== -1) {

    if (navigator.appVersion.indexOf('Win') != -1) {
        axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/lightphone/api/'
    } else if (navigator.appVersion.indexOf('Mac') != -1) {
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    } else if (navigator.appVersion.indexOf('Linux') != -1) {
        // After connecting rpi, the windows laptop also goes here.
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    }

} else {
    axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/api/'
}

export default {

    methods: {

        async profileApplicationTabGetApplication() {

            let self = this;

            try {

                return await axios.get('profiles_applications.php', {
                    params: {
                        'operation': 'get'
                    }
                });

            } catch (requestError) {
                throw requestError;
            }

        },


        async profileApplicationTabSaveApplication() {

            let self = this;

            try {

                // TOOD: Convert this to post
                return await axios.get('profiles_applications.php', {
                    params: {
                        'field': self.applicationTabField,
                        'operation': 'update'
                    }
                });

            } catch (requestError) {
                throw requestError;
            }

        }

    }


}
